import { Component } from '@angular/core';
import { TableComponent } from '@shared/components/table/table.component';
import { HeaderService } from '@app/core/services/header.service';
import { ODataService } from '@app/core/services/odata/odata.service';
import { ModalService } from '@app/core/services/modal.service';
import { ODataType } from '@app/core/services/odata/types/odata-type';
import {
  dashboardCompleteModal,
  dashboardListModal,
  serviceRequestRemoveModal
} from '@views/dashboard/list-views/util/dashboard-modals.util';
import {
  DashboardServicerequestBaseComponent,
  ServiceRequestConfig
} from '@shared/modals/dashboard/query/service-request-base/service-request-base.component';
import { createActions } from '@app/core/utils/service-request.helper';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { ToggleComponent } from '@shared/components/input/toggle/toggle.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { SortDir } from '@app/core/constants/sort-dir';

@Component({
  imports: [
    TableComponent,
    ToggleComponent,
    TranslatePipe,
    ReactiveFormsModule
  ],
  templateUrl: './dashboard-servicerequest-deliverydisconnect.component.html',
})
export class DashboardServicerequestDeliverydisconnectComponent extends DashboardServicerequestBaseComponent {
  protected config: ServiceRequestConfig = {
    tableId: 'table-dashboard-query-deliverydisconnect',
    titleKey: 'dashboard.query.deliverydisconnect.title',
    odataType: ODataType.disconnectDueToEndOfSupply,
    fixedSort: { sortField: 'isCancelledBySupplier', sortDirection: SortDir.desc },
    defaultSort: { sortField: 'occurrence', sortDirection: SortDir.asc },
    activeColumns: ['meteringPointIdentification', 'address', 'meteringPointType', 'physicalStatus', 'partyName', 'settlementMethod', 'created', 'occurrence', 'actionResponse', 'serviceRequestCode', 'isCancelledBySupplier', 'reasonText'],
  };

  public form: FormGroup = new FormGroup({
    processedRequests: new FormControl(false)
  });

  constructor(
    headerService: HeaderService,
    oDataService: ODataService,
    modalService: ModalService,
    private readonly route: ActivatedRoute
  ) {
    super(headerService, oDataService, modalService);

    this.route.queryParams.subscribe(qp => {
      const processed = qp['processedRequests'] === 'true';
      this.form.get('processedRequests')!.setValue(processed, {
        emitEvent: false
      });
      this.config.customParams = {
        processedRequests: this.form.get('processedRequests')!.value.toString()
      };
    });

    // Subscribe to toggle changes
    this.form.get('processedRequests')!.valueChanges.subscribe(() => {
      this.config.customParams = {
        processedRequests: this.form.get('processedRequests')!.value.toString()
      };
      this.table?.search();
    });

    this.initialize();
  }

  protected getActions() {
    return createActions(
      {
        getSelectedElements: () => this.selectedElements,
        openCompleteModal: () => this.openCompleteModal(),
        openListModal: () => this.openListModal(),
        openRemoveModal: () => this.openRemoveModal(),
      },
      ['completeSimple', 'remove', 'list']
    );
  }

  public openCompleteModal(): void {
    this.modalService.show({
      ...dashboardCompleteModal,
      params: { actionType: 'disconnectDueToEndOfSupply', element: this.selectedElements[0] }
    }).subscribe(() => this.refreshTable());
  }

  public openListModal(): void {
    this.modalService.show({
      ...dashboardListModal
    });
  }

  public openRemoveModal(): void {
    this.modalService.show({
      ...serviceRequestRemoveModal,
      params: { element: this.selectedElements[0] }
    }).subscribe(() => this.refreshTable());
  }
}
